import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_DATE_FILTER = 'pd'

const coreApiPageFilters = [
    {
        title: 'date',
        key: 'd',
        field_name: 'date',
        data: [],
    },
]

export const coreApiPageDateFilterObject = new CoreApiFilterObject(FILTER_ID_PAGE_DATE_FILTER, FILTER_TYPES.DATE_INDICATOR, coreApiPageFilters)
